import { Controller } from "@hotwired/stimulus";

class WorldpayController extends Controller {
  static outlets = ["payment-update", "checkout-forms"];
  static targets = ["paymentSuccess", "paymentError", "paymentCancelled"];

  connect() {
    this.paymentUpdateOutlet.addAsyncSubmitInterrupt(this.handleSubmit);

    if (this.hasCheckoutFormsOutlet) {
      this.checkoutFormsOutlet.addErrorListener(this.handleSubmitError);
    } else {
      this.paymentUpdateOutlet.enableSubmit();
    }
  }

  disconnect() {
    this.paymentUpdateOutlet.removeAsyncSubmitInterrupt(this.handleSubmit);
  }

  handleSubmit = () => {
    if (this.pendingResolve) {
      this.#resolvePendingPromise(false);
    }

    this.#loadWorldpayForm();

    return new Promise((resolve, _reject) => (this.pendingResolve = resolve));
  };

  handleSubmitError = () => {
    this.#hideWorldpayForm();
  };

  paymentSuccessTargetConnected() {
    this.#resolvePendingPromise(true);
  }

  paymentErrorTargetConnected(target) {
    this.#resolvePendingPromise(false);

    this.paymentUpdateOutlet.setCustomError(target.dataset.paymentErrorMessage);
  }

  paymentCancelledTargetConnected() {
    this.#resolvePendingPromise(false);

    this.#hideWorldpayForm();
  }

  #hideWorldpayForm() {
    const url = new URL(window.location.href);
    url.searchParams.set("show_worldpay_form", "false");
    Turbo.visit(url, { frame: "worldpay_form_wrapper" });
  }

  #loadWorldpayForm() {
    const url = new URL(window.location.href);

    url.searchParams.set("show_worldpay_form", "true");
    url.searchParams.set("phone", this.#inputValue("customer_phone"));
    url.searchParams.set("patheon_site_id", this.#inputValue("location-select"));

    Turbo.visit(url, { frame: "worldpay_form_wrapper" });
  }

  #resolvePendingPromise(value) {
    if (this.pendingResolve) {
      this.pendingResolve(value);
      this.pendingResolve = null;
    }
  }

  #inputValue(elementId) {
    return document.getElementById(elementId)?.value;
  }
}

export default WorldpayController;
